@if (progress > 0) {
<div class="form-group">
  <div class="progress">
    <div class="progress-bar" [style.width.%]="progress">{{progress}}%
    </div>
  </div>
</div>
}